// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"ImageElement_imageWrapper__04WM2"};